export const selectOptionsLoanStatusOld = [
  "Prospect",
  "Terms Accepted",
  "Processing", //Sub Status: 'Appraisal Ordered', 'Appraisal In', 'Pre-Underwrite'
  "Appraisal Ordered",
  "Pre-Underwrite",
  "Appraisal In",
  "Underwriting",
  "Final Review",
  "Clear To Close", //Sub Status:  'Docs Out', 'Docs Back'
  "Closed",
  "Closed w/ Post Closing Conditions",
  "Balance Sheet",
  "Loan Sold",
  "Inactive",
  "Dead",
];

export const selectOptionsLoanStatus = [
  "Terms Accepted",
  "Processing",
  "Underwriting",
  "Condition Clearance",
  "Final Review",
  "Clear To Close",
  "Closed",
  "Inactive",
  "Dead",
];

export const loanSubStatusOptionsMap = {
  Processing: ["Appraisal Ordered", "Appraisal In", "Pre-Underwrite"],
  "Clear To Close": ["Docs Out", "Docs Back"],
  Closed: ["Funded with Post Close Conditions", "Funded"],
};
